import CtrlFormularios from './pages/CtrlFormulariosPage.vue'

const routes = [
  {
    path: 'ctrl-formularios',
    name: 'ctrl-formularios',
    component: CtrlFormularios
  }
];

export default routes;